export default __webpack_public_path__ + "static/media/show-necklace-2.13d64a27.webp";